import { isPlatformWorkerApp } from '@angular/common';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-faqs-page',
  templateUrl: './faqs-page.component.html',
  styleUrls: ['./faqs-page.component.less']
})
export class FaqsPageComponent implements OnInit {
  @ViewChildren("listElement") private itemElements!: QueryList<ElementRef> ;


  public faqList: Array<any> = [];

  constructor() { }

  ngOnInit(): void {
    this.faqList = [
      {
        title: 'Technical Requirements',
        content: [{
          question: 'Q:	What web browsers can I use for the ATRAM Partners Portal?',
          answer: "Google Chrome, Safari, and Edge (recommended: Google Chrome)"
        },
        {
          question: 'Q: What devices can I use to access the ATRAM Partners Portal?',
          answer: "Desktop, Laptop, Tablet, and Mobile Phone (recommended: Desktop and Laptop)"
        },
        {
          question: 'Q: I’m having trouble with the firewall that my company is using. How do I proceed? ',
          answer: "Kindly contact your company’s IT personnel."
        }],
      },
      {
        title: 'Getting Started',
        content: [{
          question: 'Q: How can I get access to the ATRAM Partners Portal?',
          answer: "Our partners will receive an invite link via their designated email addresses. This link will prompt you to sign-up by providing your contact number and password. Your unique company code will also be reflected on the sign-up page. If you haven't received your invite link, kindly send us an email at partnersportal@atram.com.ph for us to process your invite link."
        },
        {
          question: 'Q: My company is a partner, how many are given access to this portal?',
          answer: "Our designated partners personnels will receive an invite link via their designated email addresses. This link will prompt them to sign-up and create their accounts on the partners portal. If you are a new client, please share with us the information of your designated personnels by sending an email at partnersportal@atram.com.ph."
        },
        {
          question: 'Q: I’m an ATRAM Partner, how do I sign up?',
          answer: "Our partners will receive an invite link via their designated email addresses. This link will prompt you to sign-up by providing your contact number and password. Your unique company code will also be reflected on the sign-up page. If you haven't received your invite link, kindly send us an email at partnersportal@atram.com.ph for us to process your invite link."
        },
        {
          question: 'Q: I’m an ATRAM Partner, how do I log-in?',
          answer: 'Upon completing the registration process you will be able to login using the email, password and unique company code reflected during account creation. An OTP code will be sent to your designated contact number to verify your log-in credentials. If you cannot remember your password use the "Forgot Password" button to receive a reset email on your designated email address.'
        },
        {
          question: 'Q: Where do I find our company code?',
          answer: "Your company code is reflected upon sign-up. Kindly take note of your company code as it is required every time you log into the portal. If you cannot remember your company code please use send us an email at partnersportal@atram.com.ph."
        }],
      },
      {
        title: 'Accessibility Problems',
        content: [{
          question: 'Q: I forgot my username, how do I retrieve this?',
          answer: "The Partners Portal login requires your company email address. If you do not recall your password, simply click “Forgot my password”."
        },
        {
          question: 'Q: How do I reset my password?',
          answer: "If you do not recall your password, simply click “Forgot password”."
        },
        {
          question: 'Q: I’ve exceeded the OTP number of tries, how do I proceed?',
          answer: "Your account will be locked and receive an instruction on your registered email address to reset your password."
        },
        {
          question: 'Q: What if I get locked out of my account?',
          answer: 'An account locked prompt will be displayed and receive an instruction on your registered email address to reset your password.'
        }],
      },
      {
        title: 'Service',
        content: [{
          question: 'Q: Where do I download the forms or templates for upload? ',
          answer: "The forms or templates required for upload will be provided to the respective personnel in charge of the file submission process. To ensure you have the most up-to-date and accurate forms or templates, it is recommended to reach out to partnersportal@atram.com.ph. They will be able to provide you with the necessary instructions on how to obtain the required forms or templates and guide you through the upload procedure."
        },
        {
          question: 'Q: What filetype is supported by the portal? ',
          answer: "File types accepted: XLS, XLSX, CSV, JPG, JPEG, PNG, PDF"
        },
        {
          question: 'Q:	My file didn’t successfully upload, what should I do? ',
          answer: "Kindly send us an email at partnersportal@atram.com.ph for your question and concern."
        }],
      },
    ]
  }

  scroll(id : number) {
    let el = document.getElementById(String(id)); 
    el?.scrollIntoView({block:"center",inline: "center"});
      this.faqList.forEach(i =>{
        i['active'] = false;
      });
    this.faqList[id]['active'] = !this.faqList[id]['active'];
  }
  
  openQuestion(subj:number,id : number){
    this.faqList[subj].content[id]['active'] = !this.faqList[subj].content[id]['active'];

  }

  // goToTitle(i: number): void{
  //   document.getElementById(String(i))?.;
  // }   
}
